export const environment = {
  production: true,
  google_sso: '/google_signin',
  microsoft_sso: '/microsoft_signin'
};

